import { coachingSessionLeaveGuard } from '../scoreboard/components/video-analysis/coaching-session-leave.guard';
import { Routes } from '@angular/router';
import { authGuard } from '../../core/guards/auth.guard';
import { teamCoachGuard } from '../../core/guards/team-coach.guard';

export const myTeamRoutes: Routes = [
  {
    path: 'my-teams',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/my-teams-list/my-teams-list.component').then((m) => m.MyTeamsListComponent),
      },
      {
        path: ':teamId/playbook/formations/:id/edit',
        canActivate: [teamCoachGuard],
        loadComponent: () =>
          import('../playbook/components/formations-tab/formation-editor.component').then(
            (m) => m.FormationEditorComponent,
          ),
      },
      {
        path: ':teamId/playbook/formations/:id/view',
        loadComponent: () =>
          import('../playbook/components/formations-tab/formation-viewer.component').then(
            (m) => m.FormationViewerComponent,
          ),
      },
      {
        path: ':teamId/playbook/plays/:id',
        loadComponent: () =>
          import('../playbook/components/plays-tab/play-concept-detail.component').then(
            (m) => m.PlayConceptDetailComponent,
          ),
      },
      {
        path: ':teamId/playbook/play-variants/:id/edit',
        canActivate: [teamCoachGuard],
        loadComponent: () =>
          import('../playbook/components/plays-tab/play-variant-editor.component').then(
            (m) => m.PlayVariantEditorComponent,
          ),
      },
      {
        path: ':teamId/playbook/play-variants/:id/view',
        loadComponent: () =>
          import('../playbook/components/plays-tab/play-variant-viewer.component').then(
            (m) => m.PlayVariantViewerComponent,
          ),
      },
      {
        path: ':teamId/playbook/templates/:id/edit',
        canActivate: [teamCoachGuard],
        loadComponent: () =>
          import('../playbook/components/shared/template-editor.component').then(
            (m) => m.TemplateEditorComponent,
          ),
      },
      {
        path: ':teamId/playbook/route-tree',
        loadComponent: () =>
          import('../playbook/components/route-tree/route-tree.component').then(
            (m) => m.RouteTreeComponent,
          ),
      },
      {
        path: ':teamId/videos/scout/:footageId',
        canDeactivate: [coachingSessionLeaveGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        loadComponent: () =>
          import('./components/scout-video-page/scout-video-page.component').then(
            (m) => m.ScoutVideoPageComponent,
          ),
      },
      {
        path: ':teamId/videos/match/:matchId',
        canDeactivate: [coachingSessionLeaveGuard],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        loadComponent: () =>
          import('./components/team-match-video-page/team-match-video-page.component').then(
            (m) => m.TeamMatchVideoPageComponent,
          ),
      },
      {
        path: ':teamId/players/:playerId',
        loadComponent: () =>
          import('./components/team-player-page/team-player-page.component').then(
            (m) => m.TeamPlayerPageComponent,
          ),
      },
      {
        path: ':teamId',
        loadComponent: () =>
          import('./components/workspace/my-team-workspace.component').then((m) => m.MyTeamWorkspaceComponent),
      },
    ],
  },
  {
    path: 'find-team',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/find-team/find-team.component').then((m) => m.FindTeamComponent),
  },
  {
    path: 'teams/:teamId/my-connections',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/my-connections/my-connections.component').then((m) => m.MyConnectionsComponent),
  },
];
